module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/car-storage1.jpg";